<template>
  <div class="bezier-curve">
    <svg
        :viewBox="`0 0 ${width > 0? width + 50: 150} ${height}`"
        :style="{ height: height + 'px' }"
    >
      <defs>
        <marker
            id="lrtRpointer"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="6.6"
            orient="36"
            markerUnits="userSpaceOnUse"
        >
          <polyline points="0 1, 8 6, 0 8"/>
        </marker>
        <marker
            id="rtlRpointer"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="4.1"
            orient="-62"
            markerUnits="userSpaceOnUse"
        >
          <polyline points="0 1, 8 6, 0 8"/>
        </marker>
        <marker
            id="lrtLpointer"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="4.1"
            orient="118"
            markerUnits="userSpaceOnUse"
        >
          <polyline points="0 1, 8 6, 0 8"/>
        </marker>
        <marker
            id="rtlLpointer"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="6.6"
            orient="-144"
            markerUnits="userSpaceOnUse"
        >
          <polyline points="0 1, 8 6, 0 8"/>
        </marker>
      </defs>
      <g>
        <path
            v-if="start ==='left'"
            d="M 0 0 C 5 10, 15 10, 40 10"
            stroke="#4b4e54"
            fill="transparent"
            stroke-dasharray="0"
        />
        <path
            v-if="start ==='right'"
            :d="`M 0 ${height} C 5 ${height - 10}, 15 ${height - 10}, 40 ${height - 10}`"
            stroke="#4b4e54"
            fill="transparent"
            stroke-dasharray="0"
        />
        <path
            v-if="startPoint !==''"
            :d="`M ${startPoint} C ${controlPoints}`"
            fill="none"
            stroke="#4b4e54"
            stroke-width="1"
            stroke-dasharray="2"
            :marker-start="direction ==='rtl'? start ==='left' ? 'url(#rtlLpointer)': 'url(#rtlRpointer)' : ''"
            :marker-end="direction ==='ltr'? start ==='left' ? 'url(#lrtRpointer)' : 'url(#lrtLpointer)': ''"
        />
        <path
            v-if="start ==='right'"
            :d="`M ${width + 40} 10 C ${width + 15} 10, ${width + 5} 10, ${width} 0`"
            stroke="#4b4e54"
            fill="transparent"
            stroke-dasharray="0"
        />
        <path
            v-if="start ==='left'"
            :d="`M ${width + 40} ${height-10} C ${width + 15} ${height-10}, ${width + 5} ${height-10}, ${width} ${height}`"
            stroke="#4b4e54"
            fill="transparent"
            stroke-dasharray="0"
        />
      </g>
      <g>
        <rect
            rx="10"
            ry="10"
            :x="centerPoint.x - 50"
            :y="centerPoint.y - 8"
            width="100"
            height="20"
            fill="white"
            stroke="#4b4e54"
            stroke-width="1"
        />
        <text
            v-if="lateralMovementSrcProcess"
            x="50%"
            y="50%"
            text-anchor="middle"
            alignment-baseline="middle"
            fill="#4b4e54"
            font-size="12px"
            :font-family="globalStyles.fontFamily"
            dy=".3em"
        >{{ lateralMovementSrcProcess }}
        </text>
      </g>
      <g v-if="occurrence > 1">
        <ellipse
            :rx="occurrence > 999? 14: 10"
            :ry="occurrence > 999? 14: 10"
            :cx="centerPoint.x + 50"
            :cy="centerPoint.y + 8"
            fill="#e8ecf4"
            stroke="#4b4e54"
            stroke-width="1"
        />
        <text
            :x="occurrenceCPX"
            :y="centerPoint.y + 8"
            class="caption1"
            fill="#4b4e54"
            :font-family="globalStyles.fontFamily"
            dy=".3em"
        >{{ occurrence }}
        </text>
      </g>
      <text
          class="box caption1"
          :x="width > 0 ? `${centerPoint.x - 30}`: 35"
          :y="width > 0 ? `${centerPoint.y + 25}`: 28"
          fill="#6a6e75"
      >{{ timestamp }}
      </text>
    </svg>
  </div>
</template>

<script>
import {chartGlobalLabelDefaults} from "@/constants/chart-global-styles.constants";

export default {
  name: "IocBezierCurve",
  props: {
    tableId: {type: String},
    row: {type: Object},
    direction: {
      // direction how the diagram is read
      type: String, // direction refers to ascending (ltr) or descending (rtl) order sort
      validator: val => ["ltr", "rtl"].includes(val),
      default: "ltf"
    },
    start: {
      type: String,
      validator: val => ["left", "right"].includes(val),
      default: "left"
    },
    renderWatch: {type: Number},
    rightOffset: {type: Number, default: 0},
    leftOffset: {type: Number, default: 0}
  },
  data() {
    return {
      startPoint: "",
      endPoint: "",
      controlPoints: "",
      centerPoint: {x: "", y: ""},
      height: 52,
      width: 550,
      debounceResize: {}
    };
  },
  computed: {
    globalStyles() {
      return chartGlobalLabelDefaults.style;
    },
    occurrence() {
      return this.row.occurrence;
    },
    occurrenceCPX() {
      if (this.occurrence < 10) {
        return this.centerPoint.x + 48;
      } else if (this.occurrence < 100) {
        return this.centerPoint.x + 44;
      } else if (this.occurrence < 999) {
        return this.centerPoint.x + 42;
      } else {
        return this.centerPoint.x + 40;
      }
    },
    timestamp() {
      return this.$moment(this.row.seenTime).format("MMM Do,h:mm a");
    },
    lateralMovementSrcProcess() {
      if (_.isArray(this.row.lmEventList) && this.row.lmEventList.length > 0) {
        return this.row.lmEventList[0]["sourceProcessName"].slice(0, 15);
      }
      return "";
    }
  },
  methods: {
    getMidPoint(xCoors, yCoors) {
    },
    renderIocBezierCurve() {
      /* bezier curve needs 4 points
      1. starting point (element's x, y)
      2. control point 1 x, y + height (63)
      3. control point 2 x + width, y
      4. ending point x + width, y + height (63
    */

      // Get column widths from table column headers using table id
      try {
        let tableDiv = document.getElementById(this.tableId);
        let tableEl = tableDiv.querySelectorAll("table")[1];
        // use greater width between table div or table element (overflow)
        let colWidth =
            Math.max(tableDiv.clientWidth, tableEl.clientWidth) / tableEl.rows[0].cells.length; // total width/# of hosts = col width
        let numOfCol = Math.abs(
          this.row.targetAgentColIndex - this.row.sourceAgentColIndex
        );

        // how many col should source to target span
        this.width = colWidth * numOfCol;

        // get element's position
        let bzEl = {x: 25, y: 0};
        let targetCurve = {
          height: 10,
          width: 40
        };
        // before M 25,10 C 25,62 529.5,10 529.5,62
        // after M 25,10 C 25,52 529.5,10 464,52

        // coordinates (x, y)
        let ctrlPoint1 = `${bzEl.x},${bzEl.y +
        this.height -
        targetCurve.height}`;
        let ctrlPoint2 = `${bzEl.x + this.width},${bzEl.y +
        targetCurve.height}`;
        let endPoint = `${bzEl.x + this.width + this.rightOffset},${bzEl.y +
        this.height -
        targetCurve.height}`;

        // center point ((x1 + x2) /2 )/ ((y1 + y2) /2)
        this.centerPoint.x = (bzEl.x + (bzEl.x + this.width)) / 2;
        this.centerPoint.y = this.height / 2; // height/2

        if (this.start === "right") {
          bzEl.x = this.width + 25 + this.leftOffset;
          bzEl.y = 0;
          ctrlPoint1 = `${bzEl.x},${bzEl.y + this.height}`;
          ctrlPoint2 = `${bzEl.x - this.width},${bzEl.y}`;
          endPoint = `${bzEl.x - this.width + this.rightOffset},${bzEl.y +
          this.height -
          targetCurve.height}`;
          // center point ((x1 + x2) /2 )/ ((y1 + y2) /2)
          this.centerPoint.x = (bzEl.x + (bzEl.x - this.width)) / 2;
        }

        this.startPoint = `${bzEl.x},${bzEl.y + targetCurve.height}`;
        this.controlPoints = `${ctrlPoint1} ${ctrlPoint2} ${endPoint}`;
      } catch (error) {
        console.log("Bezier curve had an error accessing table element");
      }
    }
  },
  created() {
    this.debounceResize = _.debounce(this.renderIocBezierCurve, 200)

    window.addEventListener('resize', this.debounceResize)
    this.renderIocBezierCurve();
  },
  beforeDestroy() {
    // remove resize listener from window
    window.removeEventListener('resize', this.debounceResize)
  },
  watch: {
    renderWatch: function () {
      // triggered when new host lateral movement occurs
      // wait for new host column to be added to account for col width change
      setTimeout(() => {
        this.renderIocBezierCurve();
      }, 500);
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.caption1 {
  font-size: 10px;
  color: var(--aluminum-700);
}

polyline {
  fill: none;
  stroke: #4b4e54;
  vector-effect: non-scaling-stroke;
  stroke-width: 1;
}

/* path {
  stroke-dasharray: 2;
} */
</style>



// WEBPACK FOOTER //
// src/components/curve/IocBezierCurve.vue